import * as React from 'react';

import { compose } from 'recompose';

import withCCPA from 'bundles/marketing-consent/components/withCCPA';
import withGDPR from 'bundles/marketing-consent/components/withGDPR';
import withFetchLazyImages from 'bundles/page/components/shared/utils/withFetchLazyImages';
import UnifiedAppCheckProvider from 'bundles/unified-common/providers/UnifiedAppCheckProvider';
import GlobalStyleResets from 'bundles/unified-description-page-common/components/GlobalStyleResets';

import 'css!bundles/unified-description-page-common/index';

const EnterprisePageWrapper: React.FC = ({ children }) => {
  return (
    <UnifiedAppCheckProvider>
      <GlobalStyleResets />
      {children}
    </UnifiedAppCheckProvider>
  );
};

export default compose(withGDPR, withCCPA, withFetchLazyImages)(EnterprisePageWrapper);
